import { API } from 'aws-amplify'

export const getCustomerInfo = (id: string) =>
  API.get('BOC_API', `/getmdcustomer/${id}`, {
    headers: {
      app: 'iotmon',
    },
  })

export const updateCustomerInfo = (id: string, newInfo: any) =>
  API.post('BOC_API', `/updatemdcustomer/${id}`, {
    headers: {
      app: 'iotmon',
    },
    body: newInfo,
  })
